module.exports = __webpack_public_path__ + "img/yxdc.206b9268.png";